import React, {Component} from 'react';
import {Container, Row, Col} from 'react-bootstrap';
import './Video.css';
import OsrwNav from './CustomNavbar';
import GibButtons from './GibButtons';
import YouTube from "react-youtube";


let ytOpts = {
    height: (390 * 1.3).toString(),
    width: (640 * 1.3).toString(),
    // https://developers.google.com/youtube/player_parameters
    playerVars: {
        autoplay: 0,
        playsinline: 0
    }
};

export default class Video extends Component {

    _onReady(event) {
        // access to player in all event handlers via event.target
        event.target.pauseVideo();
    }

    render() {
        let {appData} = this.props;
        const isMobile = appData.isMobile;
        if (isMobile) {
            ytOpts.height = Math.floor((390 * 0.54)).toString();
            ytOpts.width = Math.floor((640 * 0.54)).toString();
        }
        const videoId = appData.youtubeVideos[appData.selectedYoutubeVid].id;
        const rowStyle = {marginTop: '20vh'};
        return (
            <Container>
                {isMobile ?
                    (<Row style={rowStyle}>
                        <Col xs={16} sm={9}>
                            <YouTube
                                videoId={videoId}
                                opts={ytOpts}
                                onReady={this._onReady}
                            />
                        </Col>
                        <Col xs={16} sm={9}>
                            <GibButtons style={{marginTop: "3rem"}}/>
                        </Col>
                    </Row>) :
                    (<Row style={rowStyle}>
                        <Col xs={16} sm={9} className="main-section">
                            <YouTube
                                videoId={videoId}
                                opts={ytOpts}
                                onReady={this._onReady}
                            />
                        </Col>
                        <Col xs={8} sm={3} className="sidebar-section">
                            <GibButtons style={{marginTop: "3rem"}}/>
                        </Col>
                    </Row>)
                }
                <OsrwNav appData={appData} initColor="#000000BF"/>
                <Row style={{marginBottom: '10rem'}}/>
            </Container>
        )
    }
}
